import React from 'react';
import styled, { css } from 'styled-components';

const sLineHeight = '18px';
const sFontSize = '13px';
const rowLineHeight = sLineHeight;
const rowFontSize = sFontSize;
const rowCellPadding = '4px';
const rowHeight = `calc(${rowLineHeight} * 2 + ${rowCellPadding} * 2)`;

const DataCellWrapper = styled.td`
  padding: 0 0.5em;
`;

const DataCellInner = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

const DataCell = ({ children, ...restProps }) => (
  <DataCellWrapper {...restProps}>
    <DataCellInner>{children}</DataCellInner>
  </DataCellWrapper>
);

const HeaderCell = styled.th`
  padding: 0 6.5px;
  text-align: ${props => props.textAlign || 'left'};
  position: relative;
`;

const rowLoadingStyles = css`
  &:after {
    content: ' ';
    z-index: 10;
    display: block;
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.3);
    width: 100%;
    height: ${rowHeight};
  }
`;

const rowHeaderStyles = css`
  font-size: 15px;
  font-weight: 17px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  height: ${rowHeight};
  padding-top: 12px;
  padding-bottom: 12px;
`;

const RowInner = styled.tr`
  position: relative;
  flex-direction: column;
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  font-size: ${rowFontSize};
  line-height: ${rowLineHeight};
  margin-right: ${props => props.theme.dimensions.scrollbar.width};
  ${props => props.isHeader && rowHeaderStyles}
  ${props => props.isLoading && rowLoadingStyles}
  &:hover {
    background-color: ${props => (props.isHeader ? 'none' : 'rgba(255, 255, 255, 0.1)')};
  }
`;

const Row = ({ after, children, ...restProps }) => (
  <React.Fragment>
    <RowInner {...restProps}>{children}</RowInner>
    {after && (
      <tr>
        <DataCell colSpan={15}>{after}</DataCell>
      </tr>
    )}
  </React.Fragment>
);

const TableInner = styled.table`
  // height: 100%;
`;

const TableWrapper = styled.div`
  display: block;
  overflow-x: auto;
  white-space: nowrap;
  height: ${props => (props.isSticky ? '100%' : 'auto')};
`;

const Table = ({ children, isSticky, ...restProps }) => (
  <TableWrapper isSticky={isSticky}>
    <TableInner {...restProps}>{children}</TableInner>
  </TableWrapper>
);

export default {
  Table,
  Row,
  DataCell,
  HeaderCell,
};
